<template>
  <div>
    <!-- SETA O STATUS DA PAGINA -->
    <RF-Status v-if="statusGeral !== ''" :cpntStatus='statusGeral' :cpntIcone='false' :cpntTamanho='5'></RF-Status>
    
    <!-- MOSTRA A PAGINA -->
    <div v-else class="fin-con-ban-imp">
      <div class="campo">
        <App-Select :data-time="time" class="fin-con-ban-imp--conta"
          :cpntStatus='campos.conta.status'
          :cpntId='campos.conta.id'
          :class='campos.conta.class'
          :cpntTabIndex='campos.conta.tabIndex'
          :cpntNome='campos.conta.nome'
          :cpntValue='campos.conta.value'
          :cpntMensagem='campos.conta.mensagem'
          :cpntMensagemTipo='campos.conta.mensagemTipo'
          :cpntDisabled='campos.conta.disabled === true || (envio !== null && envio !== "")'
          :cpntMostrar='campos.conta.mostrar'
          :cpntExplica='campos.conta.explica'
          :cpntPlaceholder='campos.conta.placeholder'
          :cpntValueRef='campos.conta.valueRef'
          :cpntRouter='campos.conta.router'
          :cpntMethod='campos.conta.method'
          :cpntField='campos.conta.field'
          :cpntWhere='campos.conta.where'
          :cpntAddButForm='campos.conta.addButForm'
          :cpntKeyMostra='campos.conta.keyMostra'
          :cpntTipoOrder='campos.conta.tipoOrder'
          :cpntOrder='campos.conta.order'
          :cpntOptions='campos.conta.options'
          :cpntKeyValue='campos.conta.keyValue'
          :cpntSearchMinimo='campos.conta.searchMinimo'
          :cpntMask='campos.conta.mask'
          :cpntOptionInicialNome='campos.conta.optionInicialNome'
          :cpntOptionInicialValue='campos.conta.optionInicialValue'
          :cpntNewOption='campos.conta.newOption'
          
          :cpntOnBuscarOptions='campos.conta.onBuscarOptions'
          :cpntOnChange='campos.conta.onChange'
          :cpntOnBlur='campos.conta.onBlur'
          :cpntOnRealizaBusca='campos.conta.onRealizaBusca'
          :cpntOnKeyPressEnter='campos.conta.onKeyPressEnter'
          ref="conta"
        ></App-Select>
      </div>

      <div class="drop" :style="envio === null ? 'visibility: hidden;' : ''">
        <div ref="drop_area" class="noselect" :class="campos.seletor.class">
          <template v-if="envio !== '' && envio !== null">
            <template v-if="envio === 'validando'">
              Estamos validando o arquivo recebido.
            </template>
            <template v-else>
              Estamos processando o arquivo recebido.
            </template>
            <br/>
            <br/>
            Por favor aguarde só mais alguns instantes...
          </template>

          <!-- SETA O TITULO DO CAMPO -->
          <div class="titulo" v-show="envio === ''">
            <span>Importação OFX Bancário</span>
            <br/>
            <br/>
            Selecione ou arraste nesta área um arquivo com a extensão .ofx
            <br/>
            <br/>
          </div>

          <!-- SETA A OPÇÃO PARA ESCOLHER UM ARQUIVO -->
          <span v-show="envio === ''">
            <input :id='campos.seletor.id + "-input"' name="files[]" accept=".ofx,.OFX,.Ofx" :disabled="campos.seletor.disabled" :value="campos.seletor.value" :multiple="false" type="file" @change="campos.seletor.onChange"/>
            <label :for='campos.seletor.id + "-input"'><strong>Escolha um arquivo</strong><span> ou arraste-o aqui</span>.</label>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.fin-con-ban-imp {
  margin-top: 20px;
  width: 500px;
}

.fin-con-ban-imp > .drop {
  padding-top: 20px;
  max-height: 250px;
  min-height: 250px;
}
.fin-con-ban-imp > .drop {
  width: 500px;
  height: 200px;
  margin: 0px auto;
}
  .fin-con-ban-imp > .drop > div > .titulo {
    font-size: calc(100% + 1px);
    /* font-weight: bold; */
  }
    .fin-con-ban-imp > .drop > div > .titulo > span {
      font-weight: bold;
      text-decoration: underline;
      text-transform: uppercase
    }
  .fin-con-ban-imp > .drop > .fin-con-ban-imp-arq-box-upload {
    width: 500px;
    height: 200px;
    display: table-cell;
    vertical-align: middle;
    border-radius: 5px;

    outline: 2px dashed #92b0b3;
    outline-offset: -10px;
    -webkit-transition: outline-offset .15s ease-in-out, background-color .15s linear;
    transition: outline-offset .15s ease-in-out, background-color .15s linear;
    transition: all 0.3s ease-in-out;

    background-color: #c8dadf;
    padding: 30px 20px;
    text-align: center;
  }
    .fin-con-ban-imp > .drop > .fin-con-ban-imp-arq-box-upload > span > input {
      width: 0.1px;
      height: 0.1px;
      opacity: 0;
      overflow: hidden;
      position: absolute;
      z-index: -1;
    }
      .fin-con-ban-imp > .drop > .fin-con-ban-imp-arq-box-upload > span > label {
        cursor: pointer;
        color: #0f3c4b;
        font-size: var(--font-base-soma-15);
      }
      .fin-con-ban-imp > .drop > .fin-con-ban-imp-arq-box-upload > span > input:disabled ~ label {
        cursor: no-drop;
      }
      .fin-con-ban-imp > .drop > .fin-con-ban-imp-arq-box-upload > span > label:hover strong {
        color: #39bfd3;
        font-weight: bold;
      }
  .fin-con-ban-imp > .drop > .fin-con-ban-imp-arq-box-upload-dragover {
    outline-offset: -20px;
    outline-color: #c8dadf;
    background-color: #f9f9f9;
  }
</style>

<script>
  export default {
    data: function () {
      return {
        time: '',
        statusGeral: '',
        envio: null,
        campos: {
          conta: {
            id: 'fin-con-ban-imp--conta',
            status: '',
            nome: 'Conta',
            keyValue: 'id',
            keyMostra: [ 'nome' ],
            options: [],
            mostrar: true,
            optionInicialNome: 'Selecione',
            value: '',
            valueIni: '',
            disabled: false,
            onBuscarOptions: this.finConBanImpBuscarContas,
            onChange: this.finConBanImpOnChangeValue
          },
          seletor: {
            id: 'fin-con-ban-imp--arquivo',
            class: 'fin-con-ban-imp-arq-box-upload',
            value: '',
            qrcode: '',
            disabled: false,
            onChange: this.finConBanImpOnChangeInput
          }
        }
      }
    },
    mounted: function () {
      this.finConBanImpSeletorObservadorIniciar()
    },
    methods: {
      finConBanImpBuscarContas: function (callback, id, total = null, registros = []) {
        if (total === null || total < registros.length) {
          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 } }

          // SETA OS CAMPOS QUE DEVEJA 
          queryGet.field = { id: null, tp_conta: null, id_banco: null, agencia: null, agencia_dv: null, conta: null, conta_dv: null }

          // SETA O WHERE QUE DEVE REALIZAR
          queryGet.where = { aAnd: [ { f: 'id', o: '<>', v: '1' }, { f: 'status', o: '=', v: '1' } ] }

          // FAZ A BUSCA DOS DADOS
          this.$store.state.comunicaAPI('/financeiro/config/conta/get/', 'GET', queryGet, (apiSuccess) => {
            // JUNTA OS VALORES RECEBIDOS
            registros = registros.concat(apiSuccess.data)

            // CHAMA A FUNÇÃO PARA BUSCAR OS PROXIMOS REGISTROS
            this.finConBanImpBuscarContas(callback, id, Number(apiSuccess.countAll), registros)
          }, (apiError) => {
            // SETA OS VALORES RECEBIDOS
            this.campos.conta.status = apiError

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          })
        } else if (total === 0) {
          // SETA OS VALORES RECEBIDOS
          this.campos.conta.onBuscarOptions = null

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        } else {
          // TRATA OS VALORES RECEBIDOS
          for (var indexR in registros) {
            // INICIA A VARIAVEL COM O NOME
            registros[indexR].nome = ''

            // MONTA O NOME DO BANCO A SER MOSTRADO
            if ([ '1' ].indexOf(registros[indexR].id) !== -1) {
              registros[indexR].nome = registros[indexR].id_banco
            } else {
              // INICIA A VARIAVEL PARA O CAMINHO DO ICONE DO BANCO
              registros[indexR]._img = '/img/banco/' + registros[indexR].id_banco + '.png'

              // ADICIONA O NUMERO DA AGENCIA
              if ([ '', null, undefined ].indexOf(registros[indexR].agencia) === -1) {
                // SETA O NUMERO DA AGENCIA
                registros[indexR].nome = 'AG.' + registros[indexR].agencia

                // SETA O DIGITO DA AGENCIA
                if ([ '', null, undefined ].indexOf(registros[indexR].agencia_dv) === -1) {
                  registros[indexR].nome += '-' + registros[indexR].agencia_dv
                }
              }
              
              // ADICIONA O NUMERO DA CONTA
              if ([ '', null, undefined ].indexOf(registros[indexR].conta) === -1) {
                // SETA A INICIAL DA CONTA
                registros[indexR].nome += ' C'

                // SETA O TIPO DA CONTA
                switch (registros[indexR].tp_conta) {
                  case '1':
                    registros[indexR].nome += 'C'
                    break

                  case '2':
                    registros[indexR].nome += 'P'
                    break
                }

                // FINALIZA O NOME DA CONTA
                registros[indexR].nome += '.' + registros[indexR].conta

                // SETA O DIGITO DA CONTA
                if ([ '', null, undefined ].indexOf(registros[indexR].conta_dv) === -1) {
                  registros[indexR].nome += '-' + registros[indexR].conta_dv
                }
              }
            }
          }

          // SETA OS VALORES RECEBIDOS
          this.campos.conta.options = registros

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        }
      },
      finConBanImpOnChangeValue: function (value, id) {
        // PEGA O NOME DO CAMPO QUE ESTÁ SENDO ALTERADO
        var indexF = id.split('--')

        // SETA O VALOR RECEBIDO
        this.$set(this.campos[indexF[1]], 'value', value)

        // LIMPA O CAMPO DE MENSAGEM DE ERRO
        this.$set(this.campos[indexF[1]], 'mensagem', '')

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // VERIFICA A AÇÃO QUE DEVE FAZER PARA CADA CAMPO
        switch (indexF[1]) {
          case 'conta':
            // PEGA O VALOR SELECIONADO
            var selected = typeof value === 'string' ? value : value.id

            // VERIFIFCA O VALOR QUE DEVE COLOCAR NO CAMPO
            this.envio = selected === '' ? null : ''
            break
        }
      },
      finConBanImpSeletorObservadorIniciar: function (tentativa = 0) {
        if (tentativa <= 10) {
          setTimeout(() => {
            if ([ '', null, undefined ].indexOf(this.$refs) !== -1 || [ '', null, undefined ].indexOf(this.$refs.drop_area) !== -1) {
              this.finConBanImpSeletorObservadorIniciar((tentativa + 1))
            } else {
              var funcao = (force = false, requestId = '') => {
                if (force === true || this.campos.seletor.requestId === requestId) {
                  // SETA A CLASSE DO CAMPO
                  this.campos.seletor.class = [ 'fin-con-ban-imp-arq-box-upload' ]

                  // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                  this.time = new Date().getTime()
                }
              }

              // ADICIONA O EVENTO AO COLOCAR UM ARQUIVO SOBRE O CAMPO
              $(this.$refs.drop_area).on('dragover', (event) => {
                // PARA A AÇÃO DO EVENTO
                event.stopPropagation()
                event.preventDefault()

                // SETA O REQUEST ID
                var flag = Math.floor(Math.random() * (9999 - 1000)) + 1000

                // SETA O ID GERADO
                this.campos.seletor.requestId = flag

                // SETA A CLASSE DO CAMPO
                this.campos.seletor.class = [ 'fin-con-ban-imp-arq-box-upload', 'fin-con-ban-imp-arq-box-upload-dragover' ]

                // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                this.time = new Date().getTime()

                // CHAMA A FUNÇÃO PARA LIMPAR O STATUS APÓS 200MS
                setTimeout(function () { funcao(false, flag) }, 200)
              })

              // ADICIONA O EVENTO AO TIRAR UM ARQUIVO SOBRE O CAMPO
              $(this.$refs.drop_area).on('dragenter', (event) => {
                // PARA A AÇÃO DO EVENTO
                event.stopPropagation()
                event.preventDefault()

                // CHAMA A FUNÇÃO PARA LIMPAR O STATUS
                funcao(true)
              })

              // ADICIONA O EVENTO AO TIRAR UM ARQUIVO SOBRE O CAMPO
              $(this.$refs.drop_area).on('drop', (event) => {
                // PARA A AÇÃO DO EVENTO
                event.stopPropagation()
                event.preventDefault()

                // DESABILITA O INPUT PARA INSERIR NOVO
                this.campos.seletor.disabled = true

                // LIMPA O STATUS PARA PARAR O PROCESSO
                this.campos.seletor.requestId = ''

                // INICIAR O INPUT QUE RECEBE OS ARQUIVOS
                this.campos.seletor.value = []

                // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                this.time = new Date().getTime()

                // CHAMA A FUNÇÃO PARA SALVAR OS ARQUIOS
                this.finConBanImpArquivoLer(event.originalEvent.dataTransfer.files[0])

                // CHAMA A FUNÇÃO PARA VERIFICA OS DADOS DO SELETOR
                this.finConBanImpVerificarStatusSeletor()
              })
            }
          }, tentativa === 0 ? 1 : 200)
        }
      },
      finConBanImpOnChangeInput: function (event) {
        // LIMPA OS DADOS DO INPUT
        this.campos.seletor.value = ''

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // PEGA O ARQUIVO
        var arquivo = [ '', null, undefined ].indexOf(event.clipboardData) === -1 ? event.clipboardData : event.target

        // VERIFICA SE TEM ALGUM ARQUIVO PARA SALVAR
        if (arquivo.files.length >= 1) {
          // DESABILITA O INPUT PARA INSERIR NOVO
          this.campos.seletor.disabled = true

          // INICIAR O INPUT QUE RECEBE OS ARQUIVOS
          this.campos.seletor.value = []

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // CHAMA A FUNÇÃO PARA SALVAR OS ARQUIOS
          this.finConBanImpArquivoLer(arquivo.files[0])
        }

        // CHAMA A FUNÇÃO PARA VERIFICA OS DADOS DO SELETOR
        this.finConBanImpVerificarStatusSeletor()
      },
      finConBanImpVerificarStatusSeletor: function () {
        // VERIFICA SE TEM ALGUM ARQUIVO SELECIONADO
        this.campos.seletor.disabled = this.envio !== null
        
        // VERIFICA O STATUS DO CAMPO
        switch (this.campos.seletor.disabled) {
          case true:
            // SETA A CLASSE DO CAMPO
            this.campos.seletor.class = [ 'fin-con-ban-imp-arq-box-upload', 'fin-con-ban-imp-arq-box-upload-dragover' ]
            break

          case false:
            // SETA A CLASSE DO CAMPO
            this.campos.seletor.class = [ 'fin-con-ban-imp-arq-box-upload' ]
            break
        }

        // INICIAR O INPUT QUE RECEBE OS ARQUIVOS
        this.campos.seletor.value = []

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      finConBanImpArquivoLer: function (file) {
        // SETA O VALOR RECEBIDO
        this.envio = 'validando'

        // INICIA A LEITURA DO ARQUIVO
        var reader = new FileReader()

        // CHAMA A FUNÇÃO PARA VERIFICA OS DADOS DO SELETOR
        this.finConBanImpVerificarStatusSeletor()

        // SETA FUNÇÃO DE SUCESSO DE LEITURA
        reader.onload = () => {
          // PEGA O ARQUIVO RECEBIDO
          var arquivo = reader.result

          // SETA O VALOR RECEBIDO
          this.envio = arquivo

          // FAZ A VERIFICAÇÃO DE ERRO
          try {
            // INICIA O FORMULARIO QUE SERÁ ENVIADO
            var formData = {}

            // SETA O NUMERO DA CONTA QUE ESTÁ SENDO ENVIADO
            formData.id_conta = typeof this.campos.conta.value === 'string' ? this.campos.conta.value : this.campos.conta.value.id

            // SETA O ARQUIVO RECEIBO
            formData.ofx_b64 = window.btoa(this.envio)

            // CHAMA FUNÇÃO PARA COMUNICAR COM API
            this.$store.state.comunicaAPI('/financeiro/ofx/importar', 'POST', formData, (retorno) => {
              // TRATA A MENSAGEM RECEBIDA
              this.$store.state.TRATAR_RET_LOT_API(retorno, null)

              // SETA O VALOR RECEBIDO
              this.envio = null

              // LIMPA O VALOR DO CAMPO
              this.campos.conta.value = ''

              // CHAMA A FUNÇÃO PARA VERIFICA OS DADOS DO SELETOR
              this.finConBanImpVerificarStatusSeletor()
            }, () => {
              // SETA O VALOR RECEBIDO
              this.envio = null

              // LIMPA O VALOR DO CAMPO
              this.campos.conta.value = ''

              // CHAMA A FUNÇÃO PARA VERIFICA OS DADOS DO SELETOR
              this.finConBanImpVerificarStatusSeletor()
            }, (apiValid, apiStatus) => {
              // IMPORTA A FUNÇÃO QUE SERÁ UTILIZADA
              const FUN_TRATAR_VALIDACAO_API = require('@/assets/js/Funcoes-Gerais.js').FUN_TRATAR_VALIDACAO_API

              // FAZ A VERIFICAÇÃO E MONTAGEM DO FORMULARIO
              FUN_TRATAR_VALIDACAO_API(apiValid, apiStatus, {}, this).then(() => {
                // SETA O VALOR RECEBIDO
                this.envio = null

                // LIMPA O VALOR DO CAMPO
                this.campos.conta.value = ''

                // CHAMA A FUNÇÃO PARA VERIFICA OS DADOS DO SELETOR
                this.finConBanImpVerificarStatusSeletor()
              })
            })
          }
          catch (e) {
            // APRESENTA O ERRO RECEBIDO
            this.$store.state.msgWarn('WEB [500]: ' + e.message, 'danger')

            // SETA O VALOR RECEBIDO
            this.envio = null

            // CHAMA A FUNÇÃO PARA VERIFICA OS DADOS DO SELETOR
            this.finConBanImpVerificarStatusSeletor()
          }
        }

        // FAZ A LEITURA DO ARQUIVO RECEBIDO
        reader.readAsBinaryString(file)
      }
    }
  }
</script>
